import { type MCPServerInfo } from '../../types';

const WebflowServer: MCPServerInfo = {
  serverId: 'WEBFLOW',
  name: 'Webflow',
  slug: 'webflow',
  description: 'Interact with Webflow to manage your websites and more.',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.webflow.com/mcp',
    transport: 'STREAMABLE_HTTP'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default WebflowServer;
